var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #000;\n        stroke-miterlimit: 10;\n        stroke-width: 3px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m28.5,56.21c0,4.97,4.03,9,9,9s9-4.03,9-9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m17.66,56.21h39.68c2.3,0,3.75-2.22,2.61-4l-2.87-4.5c-.43-.67-.65-1.43-.65-2.21v-18.77c0-9.15-7.98-16.94-18.23-17.27-10.76-.34-19.61,7.34-19.61,16.86v19.17c0,.77-.23,1.53-.65,2.21l-2.87,4.5c-1.14,1.78.31,4,2.61,4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/__Notifications.cd1f3317235ff59ac0f61372c8a1d9dc.svg";
export { ForwardRef as ReactComponent };